module.exports = __webpack_public_path__ + "static/img/z3.b1b1c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/association/z3.png
// module id = YNcg
// module chunks = 2